import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { searchRequest } from "../../store/actions/globalSearch";
import SearchResultCard from "./SearchResultCard";
import locationIcon from '../../assets/location.svg';
import DeviceIcon from "../../assets/device.svg";
import SearchIcon from "../../assets/search.svg";
import { sanitizeSVG } from "../../global/utility/Utils";
import { Modal } from "antd";


function GlobalSearch({ visible, onClose }) {
  const searchQuery = useSelector((state) => state.globalSearch.query);
  const [searchParams, setSearchParams] = useState(searchQuery);
  const [search, setSearch] = useState(decodeURI(searchParams));
  const dispatch = useDispatch();
  const searchResultData = useSelector((store) => store.globalSearch.result);
  console.log("searchResultData", searchResultData);
  const user = useSelector(
      (state) => state.auth.user
    );

  // useEffect(() => {
  //   setSearch(decodeURIComponent(searchParams));
  //   dispatch(searchRequest(searchParams))
  // }, [searchParams, dispatch, user?.accountId]);

  const onHandleSearchSubmit = (e) => {
    e.preventDefault();
    if (search?.length > 0) {
      // setSearchParams(search);
       setSearch(decodeURIComponent(search));
    dispatch(searchRequest(search))
    }
  };

  return (
    <Modal open={visible} onCancel={onClose} footer={null} width={800} className="custom-modal" >
      <div className="d-flex flex-column">
        <h1 className="model-heading-search font-face-vz-eDS">Search</h1>
        <form
          className="search-form"
          onSubmit={onHandleSearchSubmit}
          style={{
            position: "relative",
            display: "flex",
            alignItems: "center",
          }}
        >
          <img
            src={sanitizeSVG(SearchIcon)}
            alt="search icon"
            style={{
              position: "absolute",
              left: "20px",
              pointerEvents: "none",
            }}
          />

          <input
            type="search"
            placeholder="Enter Search Criteria"
            value={decodeURI(search)}
            onChange={(e) => setSearch(e.target.value)}
            style={{
              paddingLeft: "45px",
            }}
          />
        </form>

        <SearchResultCard
          titleIcon={sanitizeSVG(DeviceIcon)}
          titleText="Devices"
          totalResult={searchResultData.totalDevices}
          results={searchResultData.devices}
          viewMoreLink={{ isState: true, url: "/devices", state: { deviceId: search } }}
        />
        {/* <SearchResultCard
          titleIcon={OrgIcon}
          titleText="Organizations"
          totalResult={searchResultData.organizations.length}
          results={searchResultData.organizations}
          viewMoreLink={{ isState: true, url: "/organization", state: { search: search } }}
        /> */}
        <SearchResultCard
          titleIcon={sanitizeSVG(locationIcon)}
          titleText="Locations"
          totalResult={searchResultData.locations.length}
          results={searchResultData.locations}
          viewMoreLink={{ isState: true, url: "/locationdetails", state: { search: search } }}
        />
      </div>
    </Modal>
  );
}

export default GlobalSearch;